// Keyboard-shortcuts tips modal (verbatim markup from getHTML #tipsModal).
export function TipsModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <div className="tips-modal" style={{ display: open ? "block" : "none" }}>
      <div className="tips-modal-content">
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <h3>Keyboard Shortcuts</h3>
        <div className="tips-list">
          <div className="tip-row"><kbd>S</kbd><span>Search tab</span></div>
          <div className="tip-row"><kbd>O</kbd><span>Orders tab</span></div>
          <div className="tip-row"><kbd>D</kbd><span>Data Entry tab</span></div>
          <div className="tip-row"><kbd>R</kbd><span>Forms tab</span></div>
          <div className="tip-row"><kbd>F</kbd><span>Film Drop tab</span></div>
          <div className="tip-row"><kbd>K</kbd><span>Quick search</span></div>
          <div className="tip-row"><kbd>/</kbd><span>AI search</span></div>
          <div className="tip-row"><kbd>Esc</kbd><span>Close modals</span></div>
        </div>
        <p className="tips-note">Shortcuts disabled when typing in input fields</p>
      </div>
    </div>
  );
}
